import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Input } from 'antd';
import Localization from '../../utils/localization';
import { accountActions } from '../../redux/actions/';

const TabNameModal = ({ currentTab, open, handleClose, currentName }) => {
    const dispatch = useDispatch();
    const updatingCustomTab = useSelector((state) => state.accounts.updatingCustomTab);

    const [tabNameInput, updateCustomTabInput] = useState(currentName);

    return (
        <Modal
            bodyStyle={{ display: 'flex', flexDirection: 'column' }}
            title={Localization.accountStructure.nameCustomTab}
            visible={open}
            onOk={() => {
                if (!updatingCustomTab) dispatch(accountActions.updateCustomTab(tabNameInput, currentTab));
                handleClose();
            }}
            okButtonProps={{ disabled: tabNameInput === '' }}
            confirmLoading={false}
            onCancel={() => handleClose()}
        >
            <Input value={tabNameInput} onChange={(e) => updateCustomTabInput(e.target.value)} />
        </Modal>
    );
};

export default TabNameModal;
